import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";

import AuthRoute from "@/components/AuthRoute";
import { OrdersHistory } from "@/components/orders/OrderHistoryPage";
import { ERROR_404_URL } from "@/core/urls";

import Template from "../shared/Template";
import OrderDetailPage from "./OrderDetailPage";
import { ORDER_HISTORY_PAGE_QUERY, ORDER_QUERY } from "./graphql";

export default function WardOrderRoutes() {
  const match = useRouteMatch();
  return (
    <Switch>
      <AuthRoute path={match.path} exact>
        <Template selectedTab="orders" docTitle="Orders">
          <OrdersHistory listQuery={ORDER_HISTORY_PAGE_QUERY} detailQuery={ORDER_QUERY} />
        </Template>
      </AuthRoute>
      <Route path={`${match.path}/:id`} component={OrderDetailPage} exact />
      <Redirect to={ERROR_404_URL} />
    </Switch>
  );
}
